import { ServiceContract } from 'src/common/models/contract'
import * as Styles from './styles'
import { SystemDescriptions } from 'src/common/descriptions'
import { formatToCurrency, formatToDisplayDate, formatToDisplayDatetime } from 'src/common/util'
import { CollapseProps, Descriptions, DescriptionsProps, Divider } from 'antd'
import { ItemCard } from '../../TicketSetction/ItemCard'

interface Props {
    currentContract: Partial<ServiceContract>
    readOnly?: boolean
    type: "SERVICE_CONTRACT" | "PAYABLE_CONTRACT"
}

export const ContractConfirmationComponent = (props: Props) => {

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT
    const commonDescriptions = SystemDescriptions.PAGES.COMMON
    const IS_SERVICE_CONTRACT: boolean = props.type === "SERVICE_CONTRACT"

    const renderHeader = () => {
        const items: DescriptionsProps['items'] = [];

        if (IS_SERVICE_CONTRACT) {
            items.push({
                key: 'CUSTOMER',
                label: descriptions.FORM.CUSTOMER.LABEL,
                children: props.currentContract?.customer?.name,

            })
        } else {
            items.push({
                key: 'DESCRIPTION',
                label: descriptions.FORM.DESCRIPTION.LABEL,
                children: props.currentContract?.description,

            })
        }

        items.push(
            {
                key: 'IS_MONTHLY',
                label: descriptions.FORM.IS_MONTHLY.LABEL,
                children: props.currentContract?.isMonthly
                    ? commonDescriptions.YES
                    : commonDescriptions.NO,
            },
            {
                key: 'START_DATE',
                label: descriptions.FORM.START_DATE.LABEL,
                children: formatToDisplayDate(props.currentContract?.startDate),
            },
            {
                key: 'PAY_DATE',
                label: descriptions.FORM.PAY_DATE.LABEL,
                children: !IS_SERVICE_CONTRACT
                    ? props.currentContract.payDate
                    : props.currentContract.isMonthly ? props.currentContract?.payDate ?? props.currentContract?.paymentDay : "--",
            },
            {
                key: 'NEXT_SERVICE_DATE',
                label: descriptions.FORM.NEXT_SERVICE_DEBIT_DATE.LABEL,
                children: props.currentContract.isActive ? formatToDisplayDate(props.currentContract?.nextServiceDebit) : "--",
            },
            {
                key: 'TOTAL',
                label: descriptions.TOTAL,
                children: formatToCurrency(props.currentContract?.total?.toString() || '0'),
            },
        )

        if (props.readOnly) {
            items.push(
                {
                    key: 'CREATED_AT',
                    label: descriptions.CREATED_AT,
                    children: props.currentContract?.createdAt
                        ? formatToDisplayDatetime(props.currentContract.createdAt)
                        : "--",
                },
                {
                    key: 'UPDATED_AT',
                    label: descriptions.UPDATED_AT,
                    children: props.currentContract?.updatedAt
                        ? formatToDisplayDatetime(props.currentContract.updatedAt)
                        : "--",
                },
            )
        }

        return <Descriptions items={items} />;
    }

    const renderDetail = () => {
        return props.currentContract?.detail?.map((item, idx) => {
            return <div key={idx}>
                <ItemCard
                    itemDetail={item}
                    isEmbed
                />
                <Divider />
            </div>
        })
    }

    const items: CollapseProps['items'] = [
        {
            key: 'CHARACTERISTICS',
            label: descriptions.CHARACTERISTICS.LABEL,
            children: <ul
                style={{ fontSize: 12, paddingLeft: 12, }}
            >
                {(props?.currentContract?.characteristics || []).map((item, idx) => <li key={idx} >{item}</li>)}
            </ul>,
        },
    ];

    return (
        <>
            {renderHeader()}
            <Divider />
            {
                IS_SERVICE_CONTRACT
                    ? renderDetail()
                    : <Styles.CharCollapse defaultActiveKey={[]} ghost items={items} style={{ width: '100%' }} />
            }
        </>
    )
}
